/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react"
import PropTypes from "prop-types"
import { useStaticQuery, graphql } from "gatsby"
import "./layout2.css"
import "normalize.css"

import Header from "./header"
import { Contact } from "./contact-mobile/contact"
import { ContactPanel } from "./contact-panel/contact-panel"
// import "./layout.css"

const Layout = ({ children }) => {
  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
    }
  `)

  return (
    <>
      <div
        style={{
          height: "100%",
          display: "flex",
          flexDirection: "column",
          backgroundColor: "#fbfbfb",
        }}
      >
        <Header siteTitle={data.site.siteMetadata.title} />
        <main
          style={{
            margin: `0 auto`,
            maxWidth: "960px",
            padding: `0 1.0875rem 1.45rem`,
            flex: "1 0 auto",
            // display: "flex",
            // flexDirection: "column",
            position: "relative",
            height: "auto",
          }}
        >
          <div
            style={{
              position: "absolute",
              left: "-200px",
              top: "50px",
              width: "200px",
            }}
          >
            <ContactPanel forMobile={false} />
          </div>
          {children}
        </main>

        <footer style={{ flexShrink: 0 }}>
          <small>
            COPYRIGHT © {new Date().getFullYear()}, STAFFORD LOCKSMITH LLC. ALL
            RIGHTS RESERVED.
          </small>
        </footer>
      </div>
      <Contact />
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
